import React, { useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { SendOtpEmail } from "../../../features/common/Slice";
import Blue_border_button from "../../../components/common_components/common_btn/blue_border_button/Blue_border_button";
import ForgetPassword from "../ForgetPassword/ForgetPassword";
import "./ForgetPasswordEmail.css";

const ForgetPasswordEmail = ({ show, setShow, selectedPartner }) => {
  console.log(selectedPartner, "selectedPartnerssssssssssssss");

  let role_id = "";

  if (selectedPartner == "admin") {
    role_id = 1;
  } else if (selectedPartner == "college") {
    role_id = 3;
  } else if (selectedPartner == "hotel") {
    role_id = 2;
  } else if (selectedPartner == "student") {
    role_id = 4;
  }

  const dispatch = useDispatch();
  const [email, setEmail] = useState("");

  const [showChangePasword, setShowChangePassword] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      setEmail(data.email);
      const sendData = new FormData();
      sendData.append("email", data.email);
      sendData.append("role_id", role_id);

      const res = await dispatch(SendOtpEmail(sendData));

      if (res.meta?.requestStatus === "fulfilled") {
        setShowChangePassword(true);
        reset();
        // setShow(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      centered
      className="ForgetPasswordEmail_modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Send OTP</Modal.Title>
      </Modal.Header>

      {/* ✅ Form must wrap everything */}
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <div className="form_holder">
            <Row>
              <Col md={12} className="mb-3">
                <Form.Group className="form_field">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter Email"
                    className={classNames({
                      "is-invalid": errors?.email,
                    })}
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        message: "Enter a valid email address",
                      },
                    })}
                  />

                  {errors?.email && (
                    <Form.Text className="text-danger">
                      {errors.email.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
            </Row>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Col className="text-center">
            <Blue_border_button
              button_text={isSubmitting ? "Sending..." : "Send OTP"}
              type="submit"
              disabled={isSubmitting}
            />
          </Col>
        </Modal.Footer>
      </Form>
      <ForgetPassword
        show={showChangePasword}
        onHide={() => setShowChangePassword(false)}
        setShow={setShow}
        email={email}
      />
    </Modal>
  );
};

export default ForgetPasswordEmail;
